/**
 * OrbDocTutorialsIntermediateGuardsENDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocTutorialsIntermediateGuardsENDocScreen
 */

import { useOrbDocTutorialsIntermediateGuardsENDocScreenLogic } from '@/hooks/traits/useOrbDocTutorialsIntermediateGuardsENDocScreenLogic';
import type { OrbDocTutorialsIntermediateGuardsENDocScreenConfig } from '@/hooks/traits/useOrbDocTutorialsIntermediateGuardsENDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocTutorialsIntermediateGuardsENDocView as OrbDocTutorialsIntermediateGuardsENDocViewEntity } from '@app/shared';
import { OrbDocTutorialsIntermediateGuardsENDocBodyView } from '@/components/traits/OrbDocTutorialsIntermediateGuardsENDocBodyView';
import { OrbDocTutorialsIntermediateGuardsENDocFooterView } from '@/components/traits/OrbDocTutorialsIntermediateGuardsENDocFooterView';
import { OrbDocTutorialsIntermediateGuardsENDocHeaderView } from '@/components/traits/OrbDocTutorialsIntermediateGuardsENDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocTutorialsIntermediateGuardsENDocScreenViewProps {
  config?: Partial<OrbDocTutorialsIntermediateGuardsENDocScreenConfig>;
}

export function OrbDocTutorialsIntermediateGuardsENDocScreenView({ config: propsConfig }: OrbDocTutorialsIntermediateGuardsENDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocTutorialsIntermediateGuardsENDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocTutorialsIntermediateGuardsENDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocTutorialsIntermediateGuardsEN" trait="OrbDocTutorialsIntermediateGuardsENDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocTutorialsIntermediateGuardsENDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocTutorialsIntermediateGuardsENDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsIntermediateGuardsENDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsIntermediateGuardsENDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocTutorialsIntermediateGuardsENDocScreenView;
